import Consulta from "views/TableList/ConsultaCostura.jsx";
import {
  DirectNewCosturaRecord,
  EditCosturaRecord,
  UpdateCosturaRecord,
} from "views/UserPage/costura";

var dashRoutes = [
  {
    path: "/Costura/Procesos",
    name: "Procesos",
    icon: "nc-icon nc-briefcase-24",
    component: Consulta,
  },
  {
    path: "/Costura/RegistroDirecto",
    name: "Registro Directo",
    component: DirectNewCosturaRecord,
    invisible: true,
  },
  {
    path: "/Costura/RegistroActDirecto",
    name: "Registro Directo",
    component: UpdateCosturaRecord,
    invisible: true,
  },
  {
    path: "/Costura/EditCostura",
    name: "Edit Costura",
    component: EditCosturaRecord,
    invisible: true,
  },
  {
    redirect: true,
    path: "/",
    pathTo: "/Costura/Procesos",
    name: "Registro",
  },
];

export default dashRoutes;
